import { Component, ChangeDetectionStrategy, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { SagView } from '../../../cases/models';
import { NgForm, NgModel } from '@angular/forms';
import { IndexCard } from '../../../../../auth/store/models';
import { TimeBudget, TimesatsNavne } from '@store/models';
import { AlertService } from '../../../../../core/alerts/alert.service';
import { LuxonUtils } from '@shared';

@Component({
    selector: 'app-resourceplan-header',
    templateUrl: './resourceplan-header.component.html',
    styleUrls: ['./resourceplan-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ResourceplanHeaderComponent {
    @Input() sag: SagView;
    @Input() timesatsNavne: TimesatsNavne[];
    @Input() timeBudgets: TimeBudget[];
    @Input() sagsansvarlige: IndexCard[];
    @Input() caseUserIds: number[];
    @Input() users: IndexCard[];
    @Output() updateClientCaseV2 = new EventEmitter<{sag: SagView, partialSag: Partial<SagView>}>();
    @Output() removeCaseUser = new EventEmitter<number>();
    @Output() addCaseUser = new EventEmitter<number>();
    @ViewChild('resourceform') form: NgForm;

    constructor(
        private alert: AlertService,
    ) { }

    sagChange(partialSag: Partial<SagView>) {
        this.updateClientCaseV2.emit({sag: this.sag, partialSag});
    }

    onRemoveUser($event: any) {
        const userToRemove = $event.value.cardId;
        this.removeCaseUser.emit(userToRemove);
    }

    onAddUser(user: IndexCard) {
        const userToAdd = user.cardId;
        this.addCaseUser.emit(userToAdd);
    }

    fraChange(fra: NgModel) {
        if (!fra.valid) { return; }
        if (!this.validFraTil(fra.value, this.sag.til) || this.isOutsideTimerBudgets(fra.value, this.sag.til)) {
            this.resetControl('fra');
            return;
        }
        this.sagChange({fra: fra.value});
    }

    tilChange(til: NgModel) {
        if (!til.valid) { return; }
        if (!this.validFraTil(this.sag.fra, til.value) || this.isOutsideTimerBudgets(this.sag.fra, til.value)) {
            this.resetControl('til');
            return;
        }
        this.sagChange({til: til.value});
    }

    private resetControl(key: string) {
        if (!this.sag[key]) { return; }
        this.form.control.get(key).setValue(this.sag[key]);
    }

    private validFraTil(fra: string | Date, til: string | Date): boolean {
        if (!fra || !til) { return true; }
        const fraLuxon = LuxonUtils.fromIso(fra);
        const tilLuxon = LuxonUtils.fromIso(til);
        if (fraLuxon > tilLuxon) {
            this.alert.createAlert(
                'Udføres fra må ikke være før udføres til!',
                'danger'
            );
            return false;
        }
        return true;
    }

    private isOutsideTimerBudgets(fra: string | Date, til: string | Date): boolean {
        if (this.timeBudgets.length === 0) { return false; }
        if (!fra && !til) { return false; }
        let isOutside: boolean;
        if (this.timeBudgets.length > 0 && (!fra || !til)) {
            isOutside = true;
        } else {
            const fraLuxon = LuxonUtils.fromIso(fra);
            const tilLuxon = LuxonUtils.fromIso(til);
            const sortedTimeBudgets = this.timeBudgets
                .filter(tb => tb.timer !== 0).sort((a, b) => a.mth - b.mth).sort((a, b) => a.aar - b.aar);
            const firstTimeBudgets = sortedTimeBudgets[0];
            const lastTimeBudgets = sortedTimeBudgets[sortedTimeBudgets.length - 1];
            const firstBudgetDate = LuxonUtils.fromObject({year: firstTimeBudgets?.aar, month: firstTimeBudgets?.mth, day: 1});
            const lastBudgetDate = LuxonUtils.fromObject({year: lastTimeBudgets?.aar, month: lastTimeBudgets?.mth, day: 1});
            isOutside = firstBudgetDate < fraLuxon.startOf('month') || lastBudgetDate > tilLuxon.endOf('month');
        }
        if (isOutside) {
            this.alert.createAlert(
                'Der må ikke være planlagte timer udenfor valgte udførselsperiode!',
                'danger'
            );
            return true;
        }
        return false;
    }
}
